export default __webpack_public_path__ + "static/media/side_bar_close.374c8ad2.svg";